<template>
  <div class="flex items-center justify-end laptop:w-2/12 h-full w-1/2">
    <Button variant="validation" @click="handleContactClick">
      {{ contactText }}
    </Button>
  </div>
</template>

<script setup lang="ts">
import Button from '@/components/atoms/button/Button.vue'

interface Props {
  contactAction?: () => void
  contactText?: string
}

const props = withDefaults(defineProps<Props>(), {
  contactAction: undefined,
  contactText: 'Nous Contacter'
})

const handleContactClick = () => {
  if (props.contactAction) {
    props.contactAction()
  } else {
    window.location.href = 'https://courdescomptes.bj/contact'
  }
}
</script>

<style scoped>
/* Styles additionnels si nécessaire */
</style>

